import React, { useState, forwardRef, useImperativeHandle, useCallback } from 'react';
import { Modal, Header } from 'semantic-ui-react';

const CommonModal = forwardRef(({
  header,
  content,         
  actions,
  closeIcon = true,
  className = '',
  onOpen,
  onClose,
  size = 'small', // 'mini', 'tiny', 'small', 'large', 'fullscreen'
  children         
}, ref) => {
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => {
    setOpen(true);
    if (onOpen)
      onOpen();
  }, [onOpen]);

  const closeModal = useCallback(() => {
    setOpen(false);
     if (onClose) onClose();
  }, [onClose]);

  useImperativeHandle(ref, () => ({
    open: openModal,
    close: closeModal,
  }));

  return (
    <Modal
      open={open}
      size={size}
      className={className}
      closeIcon={closeIcon}
      onClose={closeModal}
    >
      {header ? <Header>{header}</Header>:null}

      {(content || children) ? (
        <Modal.Content>
          <Modal.Description>
          {content || children}
          </Modal.Description>
        </Modal.Content>
      ):null}

      {actions ? <Modal.Actions>{actions}</Modal.Actions>:null}
    </Modal>
  );
});

export default CommonModal;
